<footer class="p-4 pt-0 sm:p-3 sm:pt-0">
  <mat-divider class="mb-3sm:mb-2"></mat-divider>
  <div class="md:flex md:justify-between pt-3">
    <!-- logo -->
    <div class="mb-4 md:mb-0 sm:flex sm:items-center sm:justify-center gap-3">
      <ddc-appstore-btn-small class="mt-2"></ddc-appstore-btn-small>
    </div>
    <div class="flex justify-end">
      <div>
        <h2 class="mb-2 text-sm font-semibold">Legal</h2>
        <ul>
          <li class="mb-1">
            <a class="hover:underline" href="privacypolicy">Privacy Policy</a>
          </li>
          <li class="mb-1">
            <a class="hover:underline" href="cookiepolicy">Cookie Policy</a>
          </li>
          <li>
            <a class="hover:underline" href="termsandconditions">Terms &amp; Conditions</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-footer mt-3">
    <div class="text-center">
      <span class="text-sm"
        >© 2026 <a class="hover:underline" href="https://daydic.com/">Daydic™</a>. All Rights Reserved.
      </span>
      <span class="text-sm"> v{{ _ddc_version }} </span>
    </div>
  </div>
</footer>
